// Minimal RFC 4180 CSV serializer. Fields are quoted only when they contain a
// delimiter, quote, or line break, and embedded quotes are doubled — no lossy
// stripping of characters.

export function escapeCsvField(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }

  return value;
}

export function toCsv(rows: string[][]): string {
  return rows
    .map((row) => row.map(escapeCsvField).join(','))
    .join('\r\n');
}
